module.exports = __webpack_public_path__ + "static/media/insuranceVector.24bf7486.jpg";